

















import {
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { HighlightsButtonMeta, UnfilledHighlightsButtonMeta } from '../../model';
import { BUTTON_BY_ACTION } from './actions/allActionButtons';
import BaseButtonRender from './actions/BaseButtonRender.vue';

export default defineComponent({
	components: { BaseButtonRender },
	props: {
		meta: {
			type: Object as PropType<HighlightsButtonMeta | UnfilledHighlightsButtonMeta>,
			required: true,
		},
	},
	setup() {
		return {
			BUTTON_BY_ACTION,
		};
	},
});
